export default "__VITE_ASSET__00jTpIEv__"